module.exports = __webpack_public_path__ + "img/logo_en.6087d8b8.png";